<span class="feature-tag">Feature</span>
<span class="font-small">
  <ng-content></ng-content>
</span>
